import "./BathroomRemodel.module.css";
import Navigation from "@/reusable_sections/Header";
import Remodel from "./sections/Remodel";
import QuoteProcess from "./sections/QuoteProcess";
import Estimate from "./sections/Estimate";
import Footer from "@/reusable_sections/Footer";
import BathroomRemodelServices from "./sections/BathroomRemodelServices";
import BathroomRemodelInsights from "./sections/BathroomRemodelInsights";
import ContactCallToAction from "./sections/ContactCallToAction";
import BathroomRemodelFaq from "./sections/BathroomRemodelFaq";
export default function BathroomRemodelPage() {
  return <div>
      <Navigation />
      <Remodel />
      <BathroomRemodelServices />
      <ContactCallToAction />
      <BathroomRemodelInsights />
      
      <QuoteProcess />
      <Estimate />
      <Footer />
    </div>;
}